import { createSlice, PayloadAction, current } from '@reduxjs/toolkit';
import { fetchYoutubeURLMetadata } from './extra';
import { initialCacheState } from 'store/initial-states';
import { CACHE_CATEGORY, addYouTubeURLMetaDataIntoCache } from 'utils/cache';
import {
  Video_Metadata,
  YouTubeURLMetadataType
} from 'interfaces/setting.interface';
import { cloneDeep } from 'utils/helpers/cloneDeep';

const cache = createSlice({
  name: 'cache',
  initialState: initialCacheState,
  reducers: {
    updateIsYouTubeURLMetadataFetching: (
      state,
      { payload }: PayloadAction<boolean>
    ) => {
      state.isYouTubeURLMetadataFetching = payload;
    },
    updateYouTubeURLMetadata: (
      state,
      { payload }: PayloadAction<YouTubeURLMetadataType>
    ) => {
      state.youtube_urls_metadata = payload;
    },
    updateIsYouTubeURLMetadataUpdating: (
      state,
      { payload }: PayloadAction<boolean>
    ) => {
      state.isYouTubeURLMetadataUpdating = payload;
    }
  },
  extraReducers: (builder) =>
    builder
      .addCase(fetchYoutubeURLMetadata.fulfilled, (state, { payload }) => {
        if (payload) {
          const {
            youtube_urls_metadata: { videos_metadata }
          } = current(state);
          const currentVideosMetadata = cloneDeep(videos_metadata);
          payload.videos_metadata.forEach((metadata: Video_Metadata) => {
            const index = currentVideosMetadata.findIndex(
              (meta) => meta.video_url === metadata.video_url
            );
            if (index === -1) {
              currentVideosMetadata.push(metadata);
            } else {
              currentVideosMetadata[index].title = metadata.title;
              currentVideosMetadata[index].duration = metadata.duration;
            }
          });
          const mergedMetadata = {
            ...payload,
            videos_metadata: currentVideosMetadata
          };
          state.youtube_urls_metadata = mergedMetadata;
          addYouTubeURLMetaDataIntoCache(
            CACHE_CATEGORY.YOUTUBE_URL,
            new Response(JSON.stringify(mergedMetadata))
          );
        }
        state.isYouTubeURLMetadataFetching = false;
        state.isYouTubeURLMetadataUpdating = false;
      })
      .addCase(fetchYoutubeURLMetadata.rejected, (state) => {
        state.isYouTubeURLMetadataFetching = false;
        state.isYouTubeURLMetadataUpdating = false;
      })
});

export const {
  updateYouTubeURLMetadata,
  updateIsYouTubeURLMetadataFetching,
  updateIsYouTubeURLMetadataUpdating
} = cache.actions;
export default cache.reducer;
